<template>
  <div class="bg">
    <div class="title">
			学生信息
			
		</div>
    <div class="sInfo">
      <div class="sInfo_m1">
        <div class="sInfo_m1_01">姓名：张三</div>
        <div class="sInfo_m1_01">性别：男</div>
        <div class="sInfo_m1_01">年龄：20</div>
      </div>
      <div class="sInfo_m1">
        <div class="sInfo_m1_02">学号：1231232323</div>
        <!-- <div class="sInfo_m1_02">性别：男</div> -->
      </div>
      <div class="sInfo_m1">
        <!-- <div class="sInfo_m1_02">姓名：张三</div> -->
        <div class="sInfo_m1_02">学院：上海复旦大学</div>
      </div>
			
			<div class="studentBox">
				<div class="studentBox-title">
					<van-field
					  readonly
					  clickable
						:border="false"
					  name="picker"
					  :value="value"
					  label="选择年份"
						input-align="center"
					  placeholder="点击选择年份"
					  @click="showPicker = true"
					/>
					<van-popup v-model="showPicker" position="bottom">
					  <van-picker
					    show-toolbar
					    :columns="columns"
					    @confirm="onConfirm"
					    @cancel="showPicker = false"
					  />
					</van-popup>
				</div>
				<div class="dataBox">
					<!-- <div class="notData">暂无数据</div> -->
					
					<div class="dataBox-m1">
						<div>总分：123</div>
						<div>总分等级：222</div>
					</div>
					<div class="list">
						<div class="list_th">
							<div>项目名称</div>
							<div>结果</div>
							<div>评分</div>
						</div>
						<div class="list_tr">
							<div>项目名称</div>
							<div>结果</div>
							<div>评分</div>
						</div>
						<div class="list_tr">
							<div>项目名称</div>
							<div>结果</div>
							<div>评分</div>
						</div>

					</div>
				</div>
				
			</div>
			
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
			value: '',
			columns: [],
			showPicker: false,
    }
  },
	mounted() {
		let yearArr = []
		let year = 2010
		for(let i = 0; i < 20; i++){
			year++
			yearArr.push(year)
		}
		this.columns = yearArr
	},
	methods: {
		onConfirm(value) {
			this.value = value;
			this.showPicker = false;
		},
	}
}
</script>

<style lang="less" scoped>
.bg{
  .title{
    text-align: center;
    font-size: 5vw;
    line-height: 14vw;
    font-weight: bolder;
  }
  .sInfo_m1{
    display: flex;
    width: 100%;
    background: #f5f5f5;
    .sInfo_m1_01{
      width: 33.33%;
      box-sizing: border-box;
      border: 1px solid #999;
      font-size: 4vw;
      padding: 2vw;
    }
    .sInfo_m1_02{
      text-align: center;
      width: 100%;
      box-sizing: border-box;
      border: 1px solid #999;
      font-size: 4vw;
      padding: 2vw;
    }
  }
	.studentBox{
		border: 1px solid #1989fa;
		width: 90%;
		margin: auto;
		margin-top: 4vw;
		min-height: 80vw;
		padding-bottom: 3vw;
		.studentBox-title{
			width: 70%;
			margin: auto;
			/deep/ .van-field__value{
				border: 1px solid #999 !important;
				
			}
		}
	}
	.dataBox{
		width: 90%;
		margin: auto;
		// border: 1px solid #eee;
		.notData{
			width: 100%;
			line-height: 20vw;
			font-size: 6vw;
			display: flex;
			justify-content: center;
			align-items: center;
			color: #999;
		}
		.dataBox-m1{
			width: 100%;
			display: flex;
			justify-content: space-between;
			align-items: center;
			font-size: 4vw;
			
			color: #fff;
			
			div{
				box-sizing: border-box;
				padding: 3vw 2vw;
				background: #1989fa;
				width: 49%;
				border-radius: 4px;
			}
		}
		.list{
			margin-top: 4vw;
			border: 1px solid #eee;
			// box-sizing: border-box;
			// padding: 2vw;
			.list_th{
				display: flex;
				align-items: center;
				background: #eee;
				div{
					font-size: 3.2vw;
					width: 33.33%;
					box-sizing: border-box;
					padding: 2vw;
					font-weight: 600
				}
			}
			.list_tr{
				display: flex;
				align-items: center;
				// background: #eee;
				div{
					font-size: 3.2vw;
					width: 33.33%;
					box-sizing: border-box;
					padding: 2vw;
					color: #999;
				}
			}
		}
	}
}
</style>
